export default {
  nav: {
    auction: "Enchère Publique",
    ecosystem: "L'Écosystème",
    areas: "Domaines du Projet",
    naming: "Naming Rights & Alliances",
    contact: "Contact Privé",
    cta: "Demander le Dossier Confidentiel",
  },
  hero: {
    eyebrow: "Montalbán · Caracas · Venezuela",
    badge: "Fundación Deportiva Disimil",
    lines: [
      "Le Nouvel Épicentre",
      "du Sport, de la Santé",
      "et de la Formation",
      "Professionnelle à Caracas",
    ],
    subtitle:
      "Une alliance stratégique à Montalbán qui transforme le territoire en un complexe de haute performance, d'enseignement technique supérieur et de médecine préventive.",
    ctaPrimary: "Opportunités de Naming Rights",
    ctaSecondary: "Explorer les Domaines",
    scroll: "Défiler",
  },
  marquee: [
    "Naming Rights Disponibles",
    "Montalbán · Caracas",
    "Centre de Haute Performance",
    "Académie Sportive Mcintosh",
    "Institut d'Études Supérieures du Sport",
    "Cryothérapie & Hydrothérapie",
    "Enchère Publique de Naming",
    "Fundación Deportiva Disimil",
  ],
  eco: {
    chapter: "01",
    label: "L'Écosystème",
    title: "Un écosystème quadripartite. Quatre fronts d'investissement.",
    subtitle:
      "Quatre institutions intégrées sous une gouvernance unique, chacune avec des opportunités exclusives de partenariat corporatif.",
    opportunityLabel: "Opportunité de partenariat",
    cards: [
      {
        num: "01",
        category: "Infrastructure Sportive",
        title: "Centre de Haute Performance Sportive Montalbán",
        desc: "Terrain principal en gazon synthétique, tours d'éclairage LED nocturne, vestiaires professionnels et salle de musculation de haute performance.",
        opportunity: "Naming Rights Principal du Complexe",
        badge: "Axe Sportif",
        testid: "ecosystem-card-alto-rendimiento",
      },
      {
        num: "02",
        category: "Formation de Base",
        title: "Académie Sportive Mcintosh",
        desc: "Académie de formation sportive intégrale pour des centaines d'enfants et de jeunes athlètes de la communauté.",
        opportunity: "Parrain de l'Académie et des Uniformes",
        badge: "Axe Formatif",
        testid: "ecosystem-card-mcintosh",
      },
      {
        num: "03",
        category: "Formation Académique",
        title: "Institut d'Études Supérieures du Sport Venezuela",
        desc: "Salles de certification intelligentes pour entraîneurs, arbitres et managers sportifs de tout le pays.",
        opportunity: "Sponsor Académique Titulaire",
        badge: "Axe Éducatif",
        testid: "ecosystem-card-instituto",
      },
      {
        num: "04",
        category: "Santé & Thérapie",
        title: "Centre de Réhabilitation Sportive Disimil",
        desc: "Cabinets médicaux, salles de thérapie physique, physiothérapie avancée et salles spécialisées de cryothérapie et hydrothérapie.",
        opportunity:
          "Naming du Pôle Santé — idéal pour cliniques, assureurs et pharmaceutiques",
        badge: "Axe Médical",
        testid: "ecosystem-card-rehabilitacion",
      },
    ],
  },
  trans: {
    chapter: "02",
    label: "Domaines du Projet",
    statement: "D'un espace en désuétude à une icône continentale.",
    title: "Le point de départ : un territoire chargé d'histoire, prêt à renaître",
    subtitle:
      "État actuel du complexe à Montalbán. Ce matériel — capturé sur le terrain — montre l'ampleur de l'espace que le plan directeur transformera par phases.",
    videoLabel: "Enregistrement vidéo",
    videoCaption: "Voici l'état actuel du complexe — images capturées sur le terrain, Montalbán",
    captions: [
      "Vue aérienne du terrain — secteur nord",
      "Vue aérienne du terrain — secteur sud",
      "Terrain principal — état actuel",
      "Terrain en terre — entraînements actuels",
    ],
    note: "Plan directeur par phases : récupération du terrain principal, tours LED, pavillon clinique et salles de l'institut. Les spécifications techniques sont détaillées dans le Dossier Exécutif.",
  },
  plan: {
    chapter: "03",
    label: "Plan Directeur",
    title: "Le plan directeur : voici comment le complexe peut devenir",
    subtitle:
      "Plan conceptuel original du projet. Neuf zones planifiées sur le site de Montalbán — chacune avec naming individuel disponible.",
    mapCaption: "Plan conceptuel — conception originale du projet",
    zonesTitle: "Zones du plan directeur",
    zones: [
      {
        name: "Terrain 1",
        desc: "Terrain principal en gazon synthétique avec tours d'éclairage LED nocturne.",
      },
      {
        name: "Terrain 2",
        desc: "Second terrain réglementaire pour entraînements et tournois simultanés.",
      },
      {
        name: "Centre d'Études",
        desc: "Siège de l'Institut d'Études Supérieures du Sport Venezuela.",
      },
      {
        name: "Centre Thérapeutique",
        desc: "Salles de physiothérapie, cryothérapie et hydrothérapie du Centre de Réhabilitation Disimil.",
      },
      {
        name: "Centre Médical",
        desc: "Cabinets médicaux et soins sportifs spécialisés.",
      },
      {
        name: "Gymnase",
        desc: "Salle de musculation de haute performance et préparation biomécanique.",
      },
      {
        name: "Bureaux",
        desc: "Siège administratif de la Fundación Deportiva Disimil et du Comité Technique.",
      },
      {
        name: "Cafétéria",
        desc: "Espace de détente et d'hospitalité pour athlètes, familles et visiteurs corporatifs.",
      },
      {
        name: "Stationnement",
        desc: "Stationnement pour athlètes, personnel médical et visiteurs.",
      },
    ],
    note: "Chaque zone accepte un naming individuel, un parrainage d'équipement ou une adoption complète par phase.",
  },
  naming: {
    chapter: "04",
    label: "Naming Rights & Alliances",
    title: "Liez le nom de votre marque à un héritage historique",
    subtitle:
      "Des modèles de partenariat institutionnel conçus pour maximiser le retour réputationnel. Aucun chiffre public : les conditions sont réservées à la table exécutive.",
    closing:
      "Les conditions, spécifications de retour publicitaire et cahiers des charges techniques sont remis en privé lors d'une réunion exécutive.",
    packages: [
      {
        badge: "Opportunité Principale",
        title: "Naming Rights Titulaire du Complexe",
        framing: "Enchère publique · clôture 31 déc. 2026",
        highlights: [
          "Droit de baptiser l'ensemble du complexe : 'Complexe Sportif [Votre Marque]'",
          "Présence monumentale sur la façade principale et le rond central du terrain",
          "Marque sur les accréditations, diffusions et papeterie officielle",
          "Priorité aux événements et tournées médiatiques du complexe",
        ],
        cta: "Participer aux Enchères Confidentielles",
        testid: "pkg-naming-titular",
      },
      {
        badge: "Secteur Santé & Assurances",
        title: "Naming du Pavillon Clinique et de la Salle de Cryothérapie",
        framing: "Idéal pour cliniques, assureurs et pharmaceutiques",
        highlights: [
          "Présence de marque dans la zone médicale de récupération physique",
          "Naming des salles de cryothérapie et d'hydrothérapie",
          "Visibilité directe auprès des athlètes d'élite et des patients privés",
          "Conventions préférentielles de soins pour les dirigeants alliés",
        ],
        cta: "Demander le Dossier du Pôle Santé",
        testid: "pkg-naming-clinico",
      },
      {
        badge: "Éducation Corporate",
        title: "Parrain Académique de l'Institut",
        framing: "Leadership dans la formation sportive nationale",
        highlights: [
          "Présence de marque dans les salles et laboratoires de certification",
          "Marque sur les certificats techniques officiels délivrés par l'institut",
          "Programme de bourses corporatives au nom de votre organisation",
          "Coorganisation de congrès et de journées techniques",
        ],
        cta: "Planifier la Présentation Académique",
        testid: "pkg-padrino-academico",
      },
      {
        badge: "Constructeurs & Marques",
        title: "Alliés Techniques et Dons en Nature",
        framing: "Matériaux de construction et équipement",
        highlights: [
          "Accords avec des entreprises de construction, éclairage, câblage, acier, ciment et peintures",
          "Reconnaissance permanente comme Allié Constructeur sur la plaque d'honneur",
          "Certification de contribution à la Responsabilité Sociale des Entreprises",
          "Visibilité dans les zones techniques pendant la construction et l'exploitation",
        ],
        cta: "Coordonner un Apport en Nature",
        testid: "pkg-aliados-tecnicos",
      },
    ],
  },
  auction: {
    "chapter": "05",
    "label": "Enchère Publique des Naming Rights",
    "title": "Le nom du complexe, aux enchères publiques",
    "subtitle": "Droits de dénomination pour 10 ans. L'entreprise ou la personne ayant la meilleure offre à la clôture baptisera le Centre de Haute Performance Sportive Montalbán.",
    "closesLabel": "Clôture de l'enchère",
    "closesDate": "31 décembre 2026 · 18h00 (heure du Venezuela)",
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Min",
    "seconds": "Sec",
    "leaderLabel": "Enchérisseur en tête",
    "noBids": "Aucune offre — soyez le premier",
    "bidsLabel": "Offres reçues",
    "biddersLabel": "Enchérisseurs validés",
    "termLabel": "Durée",
    "termValue": "10 ans",
    "rulesTitle": "Règles de l'enchère",
    "rules": [
      "Seuls les enchérisseurs validés au préalable par le Comité Technique participent.",
      "Les montants sont confidentiels : seuls les enchérisseurs validés et le Comité Technique les connaissent. Le public ne voit que l'enchérisseur en tête et le nombre d'offres.",
      "Chaque enchérisseur choisit d'apparaître avec son nom/entreprise ou avec un alias.",
      "Règle anti-clôture : toute offre dans les 10 dernières minutes prolonge l'enchère de 10 minutes.",
      "Le gagnant signe un contrat avec la Fondation et règle par virement bancaire, sous audit international."
    ],
    "videoLabel": "Comme dans le monde entier",
    "videoTitle": "Stades et arénas qui portent le nom d'une marque",
    "videoNote": "Allianz Arena, Emirates Stadium, Etihad Stadium, Mercedes-Benz Stadium, Estadio BBVA, Allianz Parque : des marques mondiales qui ont fait d'une enceinte sportive leur plus grande vitrine. Montalbán ouvre la même opportunité au Venezuela.",
    "ctaRegister": "M'inscrire comme enchérisseur",
    "ctaEnter": "Accéder au Portail",
    "closed": "Enchère clôturée",
    "open": "Enchère ouverte"
  },
  portal: {
    "back": "Retour au site",
    "title": "Portail des Enchérisseurs",
    "subtitle": "Enchère Publique des Naming Rights · Complexe Montalbán",
    "login": "Connexion",
    "register": "Inscription",
    "name": "Nom complet",
    "company": "Entreprise (facultatif)",
    "email": "E-mail",
    "phone": "Téléphone / WhatsApp",
    "password": "Mot de passe (min. 8 caractères)",
    "displayMode": "Comment souhaitez-vous apparaître publiquement ?",
    "showName": "Mon nom ou entreprise",
    "showAlias": "Un alias (Enchérisseur #NN)",
    "submitLogin": "Se connecter",
    "submitRegister": "Envoyer la demande d'inscription",
    "logout": "Déconnexion",
    "pendingTitle": "Inscription en validation",
    "pendingDesc": "Le Comité Technique vérifie votre demande. Vous recevrez un e-mail dès l'approbation pour pouvoir enchérir.",
    "rejectedTitle": "Inscription non approuvée",
    "rejectedDesc": "Votre demande n'a pas été validée. Si vous pensez qu'il s'agit d'une erreur, contactez-nous via le formulaire.",
    "yourAlias": "Votre identifiant public",
    "highBid": "Offre en tête",
    "minNext": "Offre minimale suivante",
    "noHigh": "Aucune offre",
    "leading": "Vous menez l'enchère",
    "outbid": "Votre offre a été dépassée",
    "notBid": "Vous n'avez pas encore enchéri",
    "bidLabel": "Votre offre (USD)",
    "placeBid": "Enchérir",
    "confirm": "Confirmez-vous votre offre de {amount} USD ? Elle est engageante.",
    "bidOk": "Offre enregistrée",
    "extended": "L'enchère a été prolongée (règle anti-clôture).",
    "history": "Historique des offres",
    "mine": "Vous",
    "closed": "L'enchère est clôturée. Merci de votre participation.",
    "closesIn": "Clôture dans",
    "welcome": "Bienvenue",
    "statusApproved": "Enchérisseur validé"
  },
  gov: {
    chapter: "06",
    label: "Gouvernance",
    title: "Gouvernance et transparence de premier ordre",
    subtitle:
      "Chaque contribution est gérée sous supervision technique, audit international et reddition de comptes institutionnelle.",
    features: [
      {
        title: "Fundación Deportiva Disimil",
        desc: "Entité juridique et organe directeur du projet : supervision technique et gestion institutionnelle.",
      },
      {
        title: "Audit par une ONG Internationale",
        desc: "Tous les fonds du projet seront audités par une ONG internationale indépendante, avec reddition de comptes périodique aux alliés.",
      },
      {
        title: "Comité Technique Exécutif",
        desc: "Ingénieurs, médecins du sport et chefs de projet supervisent chaque phase du plan directeur.",
      },
      {
        title: "Usage Exclusif des Contributions",
        desc: "Chaque contribution — en devises ou en nature — est destinée exclusivement au développement et à l'exploitation du complexe.",
      },
    ],
  },
  contrib: {
    chapter: "07",
    label: "Comment Contribuer",
    title: "Canal officiel de contribution",
    subtitle: "Des contributions directes, traçables et auditées. Sans intermédiaires.",
    bankTitle: "Dépôt ou Virement Bancaire",
    bankDesc:
      "Les coordonnées bancaires officielles en dollars (USD) sont remises avec le Dossier Exécutif Confidentiel, une fois la demande de votre organisation validée.",
    bankFields: [
      "Banque correspondante",
      "Titulaire : Fundación Deportiva Disimil",
      "Compte en dollars (USD)",
      "Référence : Projet Complejo Montalbán",
    ],
    bankCta: "Demander les Coordonnées Bancaires",
    kindTitle: "Don en Nature",
    kindDesc:
      "Matériaux de construction, éclairage LED, acier, ciment, peintures, gazon synthétique et équipement médical ou sportif.",
    kindCta: "Coordonner un Don en Nature",
    auditNote:
      "Toutes les contributions — monétaires et en nature — sont auditées par une ONG internationale et rapportées à chaque allié.",
  },
  donate: {
    badge: "Paiement sécurisé par carte",
    title: "Don par Carte",
    desc: "Contribution directe, sécurisée et traçable en dollars US. Traitée par Stripe, avec certification internationale de sécurité des paiements.",
    once: "Don Unique",
    monthly: "Allié Mensuel",
    monthlyHint: "Prélèvement mensuel récurrent. Annulable à tout moment.",
    amountLabel: "Choisissez un montant (USD)",
    custom: "Autre montant",
    customPlaceholder: "Montant en USD",
    nameLabel: "Nom ou entreprise (facultatif)",
    namePlaceholder: "Tel que vous souhaitez apparaître sur le Mur des Alliés",
    emailLabel: "E-mail (pour votre reçu)",
    emailPlaceholder: "nom@entreprise.com",
    anonymous: "Je souhaite que mon don soit anonyme",
    anonymousHint: "Votre nom ne sera pas affiché publiquement. Le reçu est envoyé par e-mail.",
    cta: "Donner par Carte",
    ctaMonthly: "Devenir Allié Mensuel",
    redirecting: "Redirection vers le paiement sécurisé…",
    error: "Le paiement n'a pas pu démarrer. Veuillez réessayer.",
    amountError: "Saisissez un montant valide entre 5 et 25 000 USD.",
    secure: "Chiffrement SSL · Vos données de carte ne transitent jamais par nos serveurs",
    wallLabel: "Mur des Alliés",
    wallTitle: "Ceux qui construisent déjà Montalbán",
    wallEmpty: "Soyez le premier nom sur ce mur.",
    wallAnon: "dons anonymes",
    wallMonthly: "Allié Mensuel",
    wallCorporate: "Entreprises alliées ayant déjà contribué",
    wallIndividual: "Alliés individuels",
    wallOnce: "Allié",
  },
  payment: {
    checking: "Confirmation de votre contribution…",
    successTitle: "Merci de construire Montalbán",
    successDesc: "Votre contribution a été reçue et sera enregistrée sous audit international. Un reçu vous a été envoyé par e-mail.",
    successMonthly: "Bienvenue comme Allié Mensuel du Complexe Montalbán.",
    pendingTitle: "Paiement en cours",
    pendingDesc: "Votre banque confirme l'opération. Nous vous informerons par e-mail une fois terminée.",
    failTitle: "Nous n'avons pas pu confirmer le paiement",
    failDesc: "La session a expiré ou le paiement n'a pas abouti. Vous pouvez réessayer.",
    cancelTitle: "Paiement annulé",
    cancelDesc: "Aucun débit n'a été effectué. Vous pouvez reprendre votre contribution quand vous le souhaitez.",
    back: "Retour au site",
    retry: "Réessayer",
  },
  contact: {
    chapter: "08",
    label: "Contact Privé",
    title: "Planifiez une présentation avec le Comité Technique",
    subtitle:
      "Chaque demande est traitée sous un strict accord de confidentialité. Réponse exécutive garantie.",
    name: "Nom du Représentant",
    company: "Entreprise ou Institution",
    email: "Email Professionnel",
    phone: "Téléphone Direct / WhatsApp",
    interest: "Domaine d'Intérêt",
    interestPlaceholder: "Sélectionnez un domaine",
    interests: [
      "Naming Général du Complexe (Enchères)",
      "Pôle Santé / Cryothérapie",
      "Pôle Académique / Institut",
      "Don de Matériaux de Construction",
      "Alliance Générale / Autre",
    ],
    message: "Commentaires additionnels (optionnel)",
    submit: "Planifier la Présentation avec le Comité Technique",
    submitting: "Envoi de la demande…",
    success:
      "Demande envoyée avec succès. Le Comité Technique vous contactera sous peu dans le cadre d'un accord de confidentialité.",
    error: "La demande n'a pas pu être envoyée. Veuillez réessayer.",
    privacy:
      "Vos informations sont utilisées exclusivement pour la gestion des alliances institutionnelles du projet.",
  },
  footer: {
    entity: "Fundación Deportiva Disimil",
    project: "Centre de Haute Performance Sportive Montalbán",
    location: "Montalbán, Municipalité Libertador, Caracas, Venezuela",
    confidentiality:
      "Documentation réservée exclusivement aux partenaires corporatifs et institutionnels.",
    navTitle: "Index",
    masterplan: "Plan Directeur",
    governance: "Gouvernance",
    contribute: "Comment Contribuer",
    rights: "© 2026 Fundación Deportiva Disimil. Tous droits réservés.",
  },
};
